<template>
    <div class="fullprog fullprog22">
        <div class="profile_page profile_page33" v-if="a==1">
            <div class="profile_header profile_header22">
                <div class="profile_title">Bien</div>
                <div class="profile_title1">venue</div>
                <div class="profile_circle"></div>
                <div class="profile_circle1"></div>
                <div class="profile_circle2"></div>
            </div>
            <div class="profile_form">
                <input type="text" v-model="loginForm.email" class="profile_input" placeholder="Login">
                <input type="password" v-model="loginForm.password" class="profile_input" placeholder="Password">
                <button class="profile_button" @click="SignIn()">connexion <span
                        class="profile_button_circle"></span></button>
                <p class="profile_forgort">
                    <a href="" class="forgot">Mot de passe oublie?</a>
                </p>
                <p class="profile_forgort">
                    <a @click="a=(a==1?2:1)" class="forgot">Signup</a>
                </p>
                
            </div>
            <div class="profile_sepatator">
                <div></div>
            </div>
            <div class="proile_social">
                <div class="">
                    <img src="https://space.monresto.menu/salon/google.png" alt="" srcset="">
                </div>
                <div class="">
                    <img src="https://space.monresto.menu/salon/facebook.png" alt="" srcset="">
                </div>
                <div class="">
                    <img src="https://space.monresto.menu/salon/apple.png" alt="" srcset="">
                </div>
            </div>
            <notifications group="login" position="top center"/>
        </div>
        <Signup v-if="a==2"></Signup>
    </div>
</template>
<script>
import Nav from './Nav.vue'

import { mapGetters, mapActions, mapMutations } from "vuex";
import moment from "moment"
import { MonthPickerInput } from 'vue-month-picker'
import Signup from './Signup.vue';

import Login from '../authentification/Login.vue'
import Orangedot from '../designs/Orangedot.vue';
import Bienvenue from '../designs/Bienvenue.vue';

import { computed } from "vue";


export default {

    data() {

        var datefilter = new Date()
        return {
            a:1,
            isLoad: false,
            datefilter: datefilter,


            commande: "",

            min: null,
            max: null,
            date: {
                from: null,
                to: null,
                month: null,
                year: null
            },

            login: 0,
            loginForm: {
                email :"",
                password:""
            },
            login_message : "",
            formedit: {
                nom: "",
                prenom: "",
                email: "",
                adresse: "",
                telephone: "",
            },
        }
    },
    components: {
        Nav,
        // 'Nav':Nav ,
        MonthPickerInput,
        Login,
        Orangedot,
        Bienvenue,
        Signup,

    },

    computed: {
        ...mapGetters(["clientProg", "cltprg", "lastthree"])
    },
    methods:
    {

        ...mapActions(["getClientProg", "editClient", "getlastthree", "loginProg"]),
        ...mapMutations(["getClientSuccess", "getLatestSuccess"]),
        SignIn() {
            let email = this.loginForm.email;
            let password = this.loginForm.password;


            const form = {
                email: email,
                password: password,
            };
            this.loginProg(form).then((res) => {
                if (res.ok) {
                    // window.location.href = '/'
                    // this.$router.push('/client')
                    this.getClientProg()
                    if(res.message_success){
                    // this.login_message = res.message_success
                    this.$notify({
                        group: "login",
                        type: "success",
                        title: "Réussi",
                        text: "reussi"
                    });
                    }
                    
                    console.log(res.client)
                    // this.addClientSuccess(res.client)
                    // this.saveClient();
                    // this.CheckOrder();
                }
                else if(!res.ok){
                    // this.login_message = res.message_error
                    this.$notify({
                        group: "login",
                        type: "error",
                        title: "Erreur",
                        text: res.message_error
                    });
                    }
                // this.$router.push('Login')
            })
        },
        lastfour(checknum) {
            var lastfour = checknum.substr(checknum.length - 4);
            return lastfour;

        },
        convertdate() {
            // const now = new Date()
            // let datefilter = this.datefilter
            //const today = new Date(datefilter.getMonth(), datefilter.getDate())
            //this.datefilter= today
            let maxdate = moment(this.datefilter).endOf('month').format()
            maxdate = moment(maxdate, moment.ISO_8601)
            let mindate = moment(this.datefilter).startOf('month').format()
            mindate = moment(mindate, moment.ISO_8601)
            // let mindate=moment(this.datefilter).startOf('month').format("YYYY-MM-DD")
            let payload = {
                maxdate: maxdate,
                mindate: mindate,

            }

            return payload

        },
        calculEarn() {
            let ttl = 0;
            for (let i = 0; i < this.cltprg.length; i++) {
                ttl = ttl + this.cltprg[i].points
            } return ttl.toFixed(2)
        },
        calculCredit() {
            let ttl = 0;
            for (let i = 0; i < this.cltprg.length; i++) {
                if (this.cltprg[i].total) {
                    ttl = ttl + this.cltprg[i].total
                }
            } return ttl.toFixed(2)
        },
        gotoCmd() {
            setTimeout(() => {
                this.$router.push({ name: 'Historique' })
            }, 200)
        },
        logout() {
            localStorage.setItem("accessToken", "")
            setTimeout(() => {
                this.$router.push({ name: 'Login' })
            }, 200)
        },
        responav() {
            var x = document.getElementById("myTopnav");
            if (x.className === "topnav") {
                x.className += " responsive";
            } else {
                x.className = "topnav";
            }
        },
        showModal(refname, cmd) {
            this.commande = cmd;

            this.$refs[refname].show();
        },
        hideModal(refname) {
            this.$refs[refname].hide();
        },
        firstletter() {
            let nom = Array.from(this.clientProg.nom)[0].toUpperCase();
            let prenom = Array.from(this.clientProg.prenom)[0].toUpperCase();
            let nomcom = nom.concat(' ', prenom)
            return nomcom
        },
        generateReport(cmd) {
            // this.changecmd(cmd).then(() => {
            // this.$refs.html2Pdf.generatePdf()
            // })
            this.commande = cmd;
            console.log("VOICI LA COMMANDE" + this.commande.commande.CheckNum)
            this.$refs.html2Pdf.generatePdf()

        },

        extractDate(date) {
            let datec = moment(date).format("YYYY-MM-DD")
            return datec;
        },
        async beforeDownload({ html2pdf, options, pdfContent }) {
            await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
                const totalPages = pdf.internal.getNumberOfPages()
                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i)
                    pdf.setFontSize(800)
                    pdf.setTextColor(150)
                    pdf.text('Page ' + i + ' of ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
                }
            })
            //.save()
        },

        submitForm(refname) {
            const form = {
                // id: this.$route.params.id,
                nom: this.formedit.nom,
                prenom: this.formedit.prenom,
                email: this.formedit.email,
                adresse: this.formedit.adresse,
                telephone: this.formedit.telephone,
            };
            this.editClient({ form });
            this.getClientProg().then((res) => {
                if (res.ok) {
                    this.formedit = {
                        nom: this.clientProg.nom,
                        prenom: this.clientProg.prenom,
                        email: this.clientProg.email,
                        adresse: this.clientProg.adresse,
                        telephone: this.clientProg.telephone,
                    }
                    this.$notify({
                        group: "edit-success",
                        type: "success",
                        title: "Réussi",
                        text:
                            "Vous avez modifié votre profil avec succes "
                    });
                    // this.$emit('show-connected', this.clientProg.nom);
                }
            });

            // const promise1 = new Promise((resolve, reject) => {
            //     resolve();
            // });

            // promise1.then((value) => {
            //     
            // });
            // .then((res) => {
            //     if (res.ok) {
            //         // this.$router.push({
            //         //     name: "fidelite_list_1",
            //         //     params: { restaurant: this.$route.params.restaurant }
            //         // });
            //         //window.location.reload()
            //         // $bvModal.hide('bv-modal-update')
            //     }
            //     else {
            //         console.log("NOT EDITED")
            //     }
            // })

        },

        notify() {
            this.$notify({
                group: 'foo',
                title: 'Important message',
                text: 'Hello ' + this.formedit.nom + ' ' + this.formedit.prenom + '! This is a notification!'
            });
        }

    },
    watch: {
        clientProg(newVal) {
            if (newVal) {
                this.$modal.hide("login")
                this.$modal.show("profile")
            }
        }
    },
    mounted() {
        // if(!localStorage.getItem("accessToken")){
        //     this.$router.push({ name: 'Login' })
        // }

        this.getClientProg();
        this.getlastthree().then((res) => {
            // if (res.err) {
            //     this.$router.push({ name: 'Login' })

            // } else {
            this.isLoad = true;
            this.formedit = {
                nom: this.clientProg?.nom,
                prenom: this.clientProg?.prenom,
                email: this.clientProg?.email,
                adresse: this.clientProg?.adresse,
                telephone: this.clientProg?.telephone,
                //     }

            }
        });
    }
}
</script>
<style scoped>
body {
    background-color: #1e3a34;
}

.center_all {
    /* background: linear-gradient(160deg, #1e3a34 0%, #264740 40%, #2d5249 100%); */

    display: flex;
    width: 100%;
    height: 60vh;
    justify-content: center;
    align-content: center;
    padding-top: 30vh;

}

.center_all span {
    height: fit-content;
    display: inline-block;
    flex: unset !important;
}

.login_button {

    background: linear-gradient(135deg, #D4714E, #C0603F);
    color: #fff;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 14px;
    border: none;
    cursor: pointer;
    box-shadow: 0 8px 24px rgba(212, 113, 78, 0.35);
    transition: all 0.3s ease;
}

.fullprog {
    width: 100%;
    box-sizing: border-box;
    /* background: linear-gradient(160deg, #1e3a34 0%, #264740 40%, #2d5249 100%); */
    min-height: 100vh;
}
.fullprog22{
    min-height: 40vh !important;    
}

/* 
.menu_prog div {
    width: 30px;
    height: 3px;
    background: black;
    border-radius: 5px;
    margin: 3px;
}

.pdf {
    width: 100%;
    font-size: 22px;
    margin: 0 20px;
}

.pdf .header_commande {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 10px 0 60px 30px;
}

.pdf .header_commande .logo_commande {
    width: 50%;
    display: flex;
    align-self: flex-start;
    
}

.pdf .header_commande .resto_commande {
    width: 50%;
    display: flex;
    align-self: flex-end;
    text-transform: uppercase
     
}

.pdf .header_commande .logo_prog {
    width: 160px;
}

.pdf .client_info {
    margin-left: 30px;
    display: flex;
    flex-direction: column;
} */


.prog_body {
    margin-top: 2%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.profil_clt {
    height: auto;
    /* background: linear-gradient(160deg, #1e3a34 0%, #264740 40%, #2d5249 100%); */
    margin: 20px auto;
    display: flex;
    flex-direction: row;
    padding: 30px;
    width: calc(100% - 48px);
    justify-content: center;
    align-items: center;
    border-radius: 20px;
}

.n-abbr {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px;
}

.name_abbr {

    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    background: linear-gradient(135deg, #D4714E, #C0603F);
    height: 100px;
    border-radius: 50%;
}

.infos_profil {
    color: #fff;
    margin: 0 50px;
    text-align: start;
}

.info {
    margin: 10px 0;
}

.title_pts {
    color: #D4714E;
    background-color: #fff;
    width: 60%;
    margin: 20px auto;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 14px;
    border: 1px solid #D4714E;

}

.prog_points {
    padding: 24px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px auto;

}

.prog_point {
    padding: 12px;
    background: linear-gradient(135deg, #D4714E, #C0603F);
    width: 48%;
    height: 90px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    border-radius: 14px;
    box-shadow: 0 8px 24px rgba(212, 113, 78, 0.3);
}


.title_cmd {
    color: #264740;
    background-color: #fff;
    width: 60%;
    margin: 20px auto;
    height: 50px;
    /* padding: 20px; */
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 15px;
    border: 1px solid #264740;
}

.filterbydate {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 80%;
}

.filterbydate .date {
    width: 35%;
}

.latest_cmd {
    margin: 20px auto;
    display: flex;
    flex-direction: column;

    width: calc(100% - 48px);
    justify-content: center;
    align-items: center;
    border: 1px solid #264740;
    border-radius: 5px;
}

.latest_cmd a {
    cursor: pointer;
}

.plus {
    display: flex;
    align-self: flex-end;
    font-size: medium;
    cursor: pointer;
}

.plus .a {
    color: #D4714E;
    display: flex;
    margin-right: 30px;
    margin-bottom: 10px;

}

.plus .a .circle {
    color: #fff;
    background: linear-gradient(135deg, #D4714E, #C0603F);
    width: 20px;
    height: 20px;
    margin-top: 2px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;

}

.dtls_cmd_dsng {
    width: 85%;
    height: 100%;
    border-radius: 6px;
    margin: 30px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.dtls_cmd_dsng .containercmd {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.bande_header {
    color: #666B7D;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    padding: 20px 20px;

}

.dtls_cmd_dsng .cmddtl {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #264740;
    padding: 10px 5px;
    margin: 30px 2%;
    border-bottom: 1px solid #fff;
    background-color: #fff;
    border-radius: 30px;
    cursor: pointer;
    width: 50%;
}

.dtls_cmd_dsng .cmddtl .ch_n {
    display: flex;
    background: linear-gradient(135deg, #D4714E, #C0603F);
    padding: 3%;
    border-radius: 14px;
    color: #fff;
}

.menu-wrap {
    background-color: #fff;
    /* margin-bottom: 30px; */
    width: 100%;
    border-radius: 10px;
}

.dtls_cmd_dsng .containercmd {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}


.commandes {
    display: flex;
    justify-content: space-around;
    align-items: center;
    /* padding-bottom: 15px;
    margin-bottom: 15px; */
    border-bottom: 1px dashed #ccc;
    padding: 15px;
    width: 100%;
}

.commandes p {
    margin-bottom: 0;
    display: flex;
    padding: 0 15%;
}

.commandes .text-wrap {
    width: calc(100% - 95px);
    margin-left: 15px;
    color: #666B7D;
}

.commandes .text-wrap h4 {
    font-size: 20px;
    font-weight: 300;
}

.commandes .text-wrap h6 {
    font-weight: 300;
}

.menu-price {
    text-align: right;
}

.commandes .order_info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 90%;
}

.order_status {
    display: flex;
    /* justify-content: space-around; */
    justify-content: flex-start;
    align-items: center;
}

.order_status h4,
.order_status h6 {
    width: 40%;
    background-color: #264740;
    color: #fff;
    border-radius: 15px;
    margin: 0 15px 0 0;
}

.article_list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    width: 60%;
}

.order_restau {
    display: flex;
    justify-content: flex-start;
}

#modalcmd {
    background-color: #264740;
}

.cmd_details {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    /* margin: 20% 0; */

}

.commande-ligne {
    display: flex;
    justify-content: space-between;
    /* align-items: flex-start; */
    width: 100%;
}


#modalcmd {
    background-color: #264740;
}

.cmd_details h4 {
    text-transform: uppercase;
    /*  margin: 5px 0; */
    margin: 5px 0;
    text-align: center;
    /* background-color: #264740; */
    /* background-image: url("../../../public/illustrations/maldives4.png"); */
    background-color: #264740;
    padding: 10px;
    color: #fff;
    border-radius: 10px;
}

.cmd_details .dtl_cmd {

    margin: 5px 0;
    display: flex;
    align-items: center;
}

.cmd_details .dtl_cmd ul {
    padding: 0;
}

.cmd_details h4 {
    margin: 20px 0;
}

.label-style {
    border-bottom: 1px solid #264740;
}

.menu-img {
    overflow: hidden;
    height: 30px;
    width: 30px;
    cursor: pointer
}

.menu-img img {
    transition: all .5s ease;
    /* height: 100%; */
    object-fit: cover;
}

.edit {
    background: linear-gradient(135deg, #D4714E, #C0603F) !important;
    border-radius: 14px !important;
    border: 0;
}


.submitedit {
    background-color: #264740;
    border-radius: 5px !important;
    border: 0;
}

@media screen and (max-width: 600px) {

    /* .prog_body {
    margin-top: 10%;
} */

    .grid-7 {
        margin-top: 0;
    }

    .dtls_cmd_dsng {
        width: 95%;
    }

    .dtls_cmd_dsng .cmddtl {
        width: 100%;
    }

    .cmd_details {
        margin: 10% 0;
    }

    .menu-wrap {
        width: 100%;
    }

    .commandes {
        padding: 15px 0;

    }

    .commandes p {
        padding: 0 10%;
    }

    .commandes .text-wrap h4 {
        font-size: 18px;
    }


    .submitedit {
        background-color: #264740;
        border-radius: 5px !important;
        border: 0;
    }

    .prog_body {
        margin-top: 10%;
    }
}
</style>

<style lang="scss" scoped>
.color-card {
    background: #fff;
    // background: #31394D;
    // background: #264740;
}

.generalinfo {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: row;

}

.detailinfo {
    display: flex;
    text-align: left;
    flex-direction: column;
    width: 50%;
}

.title {
    color: #7C8097;
    margin-top: 10px;
}

.followers {
    color: #666B7D;
    font-family: 10px;
    height: 10px;
}

.job-title {
    color: #7C8097;
    font-size: 12px;
}

.job-title .info-icon {
    margin-right: 5px;
}

.i-r {
    float: right;
    margin-right: 16px;
    margin-top: 16px;
    cursor: pointer;
}

.w {
    color: #264740;

}

hr {
    border-color: #7C8097;
    width: 90%;
    margin-top: 24px;
    margin-bottom: 24px;
    display: flex;
    align-self: center;
}


.content {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
}

.points-credit {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 50px;

    // background-color: #fff;
}

.pts-crdt {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: #000;
    background-color: #fff;
    width: 40%;
    margin: 0 5px;
    padding: 2% 0;
    box-shadow: 0 12px 13px rgba(0, 0, 0, 0.16), 0 12px 13px rgba(0, 0, 0, 0.16);
    transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
    border-radius: 6px;
}

.color-b {
    background: linear-gradient(135deg, #D4714E, #264740);
}

.color-c {
    background: linear-gradient(135deg, #264740, #D4714E);
}

.circule {
    border-radius: 50%;
    border: none;
    height: 60px;
    width: 60px;
    color: #ffffff;
    box-shadow: 0 13px 26px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.16);
    display: flex;
    justify-content: center;
    align-items: center;
}

.grid-2 {
    width: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 5px;
    margin: 0 10%;
    background-color: #fff;
}

.grid-7 {
    width: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 4%;
}

.label-update {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 3% 0;
}

.card {
    border-radius: 20px;
    display: flex;
    justify-content: center;
    height: auto;
    position: relative;
    width: 80%;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
    transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
    padding: 0 0 30px 0;
}


.element-animation {
    animation: animationFrames ease 2s;
    animation-iteration-count: 2;
    transform-origin: 50% 50%;
    animation-fill-mode: forwards;
    /*when the spec is finished*/
    -webkit-animation: animationFrames ease 1.5s;
    -webkit-animation-iteration-count: 1;
    -webkit-transform-origin: 50% 50%;
    -webkit-animation-fill-mode: forwards;
    /*Chrome 16+, Safari 4+*/
}

@media screen and (max-width :600px) {
    .grid-7 {
        margin-top: 0;
    }

    .card {
        width: 100%;
    }
}

@keyframes animationFrames {
    0% {
        opacity: 0;
        transform: translate(-1500px, 0px);
    }

    60% {
        opacity: 1;
        transform: translate(30px, 0px);
    }

    80% {
        transform: translate(-10px, 0px);
    }

    100% {
        opacity: 1;
        transform: translate(0px, 0px);
    }
}

.profile_page {
    width: 100%;
    min-height: 100vh;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // background: linear-gradient(160deg, #1e3a34 0%, #264740 40%, #2d5249 100%);
    padding: 40px 20px;
}

.profile_page33{
    min-height: 40vh !important;
    max-height: 60vh !important;
    overflow-x: hidden;
}
.profile_header {
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 30px 24px 10px;
    position: relative;
    text-align: center;
}


.profile_header.profile_header22 {
  max-height: 25vh !important;

}

.profile_title {
    font-size: 48px;
    font-weight: 700;
    letter-spacing: -0.5px;
    font-family: 'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
    display: inline;
}

.profile_title1 {
    font-size: 48px;
    font-weight: 700;
    letter-spacing: -0.5px;
    font-family: 'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
    display: inline;
}

.profile_circle {
    display: none;
}

.profile_circle1 {
    display: none;
}

.profile_circle2 {
    display: none;
}

.profile_form {
    display: flex;
    flex-direction: column;
    padding: 0px 24px;
    width: 100%;
    max-width: 420px;
}

.profile_input {
    padding: 16px 20px;
    background: rgba(255, 255, 255, 0.08);
    border: 1.5px solid rgba(255, 255, 255, 0.15);
    border-radius: 12px;
    margin-bottom: 14px;
    font-size: 16px !important;
    text-align: left;
    color: #fff;
    outline: none;
    transition: all 0.3s ease;
    font-family: 'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);

    &::placeholder {
        color: rgba(255, 255, 255, 0.45);
        font-weight: 400;
    }

    &:focus {
        border-color: #D4714E;
        background: rgba(255, 255, 255, 0.12);
        box-shadow: 0 0 0 3px rgba(212, 113, 78, 0.15);
    }
}

.profile_button {
    padding: 15px 0;
    background: linear-gradient(135deg, #D4714E, #C0603F);
    border: none;
    border-radius: 14px;
    margin-bottom: 14px;
    margin-top: 6px;
    font-size: 17px !important;
    font-weight: 600;
    text-align: center;
    color: #fff;
    text-transform: capitalize;
    cursor: pointer;
    transition: all 0.3s ease;
    font-family: 'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
    letter-spacing: 0.3px;
    box-shadow: 0 8px 24px rgba(212, 113, 78, 0.35);

    &:hover {
        background: linear-gradient(135deg, #e07d58, #D4714E);
        box-shadow: 0 12px 32px rgba(212, 113, 78, 0.45);
        transform: translateY(-1px);
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0 4px 16px rgba(212, 113, 78, 0.3);
    }
}

.profile_button_circle {
    display: none;
}

.profile_forgort {
    width: 100%;
    text-align: right;
    padding-right: 6px;
    margin: 4px 0;
}

.profile_forgort a {
    color: rgba(255, 255, 255, 0.65);
    text-transform: none;
    font-size: 14px;
    font-family: 'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
    text-decoration: none;
    transition: color 0.2s ease;
    cursor: pointer;

    &:hover {
        color: #D4714E;
    }
}

.profile_sepatator {
    width: 100%;
    max-width: 420px;
    height: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px 0;
}

.profile_sepatator div {
    height: 1px;
    width: 40%;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50px;
}

.proile_social {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    padding-top: 8px;
    padding-bottom: 24px;
    display: none;
    div {
        width: 52px;
        height: 52px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(255, 255, 255, 0.08);
        border: 1.5px solid rgba(255, 255, 255, 0.12);
        border-radius: 12px;
        cursor: pointer;
        transition: all 0.3s ease;
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);

        &:hover {
            background: rgba(255, 255, 255, 0.15);
            border-color: rgba(255, 255, 255, 0.25);
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
        }

        img {
            width: 24px;
            height: 24px;
            object-fit: contain;
            filter: brightness(0) invert(1);
            opacity: 0.8;
        }
    }
}

.profile_modal {
    z-index: 999999 !important;
}
</style>